export default __webpack_public_path__ + "576c63e01a3533235da3f7aa8539e39b.png";